import React, {useEffect, useState} from 'react';
import {getBrands} from "../api/HomeApi";
import {TiChevronLeftOutline} from "react-icons/ti";
import {useNavigate} from "react-router-dom";
import Loading from "../../../layouts/Loading";
import {showError} from "../../../utils/toastHelper";
import { Swiper, SwiperSlide } from 'swiper/react';

// استایل‌های پیش‌فرض Swiper را import کنید
import 'swiper/css';
const Brands = (props) => {
    const [brands, setBrands] = React.useState([]);
    const [loading, setLoading] = useState(true);

    const navigate = useNavigate();


    useEffect(() => {
        const fetchBrands = async () => {
            try {
                const params = {
                    count: props.showAll ? 80 : 10,
                    special: true,
                    orderByRand: props.showAll ? 0 : 1,
                    list: 1,
                }
                const data = await getBrands(params);
                setBrands(data?.data || []);
            } catch (err) {
                showError(err);
            } finally {
                setLoading(false);
            }
        };
        fetchBrands();
    }, []);

    if (loading) return <Loading/>;

    return (

        <section className="container   py-3 rtl px-0  ">
            {!props.showAll && (
                <div className="row mx-1">
                    <div className="col-8 home-separator-text ">
                        برند ها
                    </div>
                    <div className="col-4 text-start text-small-3 text-secondary-color mt-1"
                         onClick={
                             () => {
                                 navigate(`/brands`)
                             }
                         }
                    >
                        مشاهده همه
                        <TiChevronLeftOutline className='mx-1'/>
                    </div>

                </div>
            )

            }
            {
                props.showAll ?

            <div className="row mx-2 pb-5 mt-5 ">
                {
                    brands.map(brand => {
                        return (
                            <div
                                className={props.showAll ? "col-4 col-md-2 text-center brands " : "col-3 col-md-2 text-center brands"}
                                key={brand.id}
                                onClick={() => {
                                    navigate(`/products?b=${brand?.id}&bn=${brand?.name}`)
                                }}
                            >
                                <div
                                    className={props.showAll ? "brand-image-container bg-white" : "brand-image-container"}>
                                    <img src={brand.image} alt={brand.name}/>
                                    {props.showAll &&
                                        <div className='mt-3 text-small-3 text-muted'>
                                            {brand.name.substring(0, 15)}
                                            {
                                                brand.name.length > 15 ?
                                                    <span className='text-small-4'>
                                                    ...
                                                </span>
                                                    : ''
                                            }

                                        </div>
                                    }
                                </div>

                            </div>
                        )
                    })

                }

            </div>
                    :
            <Swiper
                // این پراپرتی کلیدی‌ترین بخش کار است
                // نمایش ۳ آیتم کامل و ۳۰٪ از آیتم چهارم
                slidesPerView={3.3}
                // فاصله بین اسلایدها
                spaceBetween={10}
                className="brands-swiper"
            >
                {brands.map(brand => (
                    <SwiperSlide key={brand.id} className="text-center brands">
                        <div
                            className={props.showAll ? "brand-image-container bg-white" : "brand-image-container"}
                            onClick={() => navigate(`/products?b=${brand.id}&bn=${brand.name}`)}
                            style={{cursor: 'pointer'}}
                        >
                            <img src={brand.image} alt={brand.name} style={{width: '100%'}}/>
                            {props.showAll && (
                                <div className='mt-3 text-small-1 text-muted'>
                                    {brand.name}
                                </div>
                            )}
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
            }
        </section>
    );
};

export default Brands;